<template>
  <div class="space-top-desktop">
    <h1 style="text-align: center">Exemplos</h1>
    <b-row style="margin-top: 50px; align-items: center; justify-content: center">
      <b-col sm="12" md="6">
        <p>
          As figuras 1 e 2 ilustram uma plataforma industrial projetada para receber piso em grade. Nas figuras, estão indicados todos os vigamentos existentes, equipamentos,
          passagem de tubulações, dutos, escadas, etc.
        </p>
      </b-col>
      <b-col sm="12" md="6" style="text-align: center">
        <img src="@/assets/images/ex_1.jpg" alt="img" class="h-100 img-fluid sec-img" />
      </b-col>
    </b-row>
    <b-row style="margin-top: 50px; align-items: center; justify-content: center">
      <img src="@/assets/images/ex_2.jpg" alt="img" class="h-100 img-fluid sec-img" />
    </b-row>
    <b-row style="margin-top: 100px; align-items: center; justify-content: center">
      <b-col sm="12" md="6">
        <p>
          Com base nas figuras 1 e 2, a SIBROL, após estudo da sequência de montagem, folgas, etc., elaborará desenho detalhado das grades (1-B e 2-B), o qual servirá para
          fabricação e montagem na obra.
        </p>
      </b-col>
      <b-col sm="12" md="6" style="text-align: center">
        <img src="@/assets/images/ex_1_a.jpg" alt="img" class="h-100 img-fluid sec-img" />
      </b-col>
    </b-row>
    <b-row style="justify-content: center;" class="mt-5">
      <img src="@/assets/images/ex_2_a.jpg" alt="img" class="h-100 img-fluid sec-img" />
    </b-row>
    <b-row style="margin-top: 50px; align-items: center; justify-content: center">
      <b-col sm="12" md="6">
        <img src="@/assets/images/img_grade17.jpg" alt="img" class="w-100 img-shadow-blue img-fluid space-top-mobile" style="margin-top: 50px" />
      </b-col>
      <b-col sm="12" md="6">
        <img src="@/assets/images/img_grade18.jpg" alt="img" class="w-100 img-shadow-blue img-fluid" style="margin-top: 50px" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Exemplos",
};
</script>
